import React, { useState, useEffect } from 'react';
//import { useParams } from "react-router-dom";
import { useParams, useLocation, useNavigate, useSearchParams, Link } from 'react-router-dom';

import './../i18n/i18n';
//import Header from './Header';
//import Hero from './Hero';
//import Navbar from './Navbar';
import TrendingCarousel from './../TrendingCarousel/TrendingCarousel';
import PublicLeaderboard from './../PublicLeaderboard/PublicLeaderboard';
import HowItWorks from './../HowItWorks/HowItWorks';
import CommunityRules from './../CommunityRules/CommunityRules';
import {DebateFeed, DebateFeedd} from './../DebateFeed/DebateFeed';
import MiniProfile from './../MiniProfile/MiniProfile';
import EngagementStats from './../EngagementStats/EngagementStats';
import NewFeatures from './../NewFeatures/NewFeatures';
import MorphingHeader from './../MorphingHeader/MorphingHeader';
import ContactSidebar from './../ContactSidebar/ContactSidebar';
import LoginForm from  './../LoginForm/LoginForm';
import AuthToggle from './../AuthToggle/AuthToggle';
import { useAuth } from "../../utils/AuthContext/authcontext";
import useScrollReveal from './../../hooks/useScrollReveal';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { useInfiniteDebateFeed } from './../../hooks/useInfiniteDebateFeed';

import styles from './Home.module.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function Home({lang, showNow}) {
  const isMobile = window.innerWidth < 768;
  const { user, userData, logout, login } = useAuth();
  const [showNav, setShowNav] = useState(false);
  const [isContactOpen, setContactOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const { notify } = useNotifications();
  const [isCompact, setCompact] = useState(showNow);
  const location = useLocation().search;
  const [lastDoc, setLastDoc] = useState(null);
  const { arenas, loadMore, loading, hasMore } = useInfiniteDebateFeed(lastDoc, setLastDoc, 10);

  /*useEffect(() => {
    const onScroll = () => setShowNav(window.scrollY > 50);
    const timer = setTimeout(() => setShowNav(true), 5000);

    window.addEventListener('scroll', onScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    };
	      {!showNav && <Hero />}
      <Navbar show={showNav} />
  }, []);*/
	//let sc = new URLSearchParams(location).get("sc");
	//console.log(sc);

  useEffect(() => {
    //window.history.scrollRestoration = 'auto'
  }, []);

	useScrollReveal(); // ?? activates scroll animation
    
	const mlogout = () => {
		notify('info', "GoodBye for now")
		if(logout != null)
			logout(true);
	}
	
	const handleJoin = (what, why) => {
		console.log(what, why);
	}
	
	return (
	<>
	  <MorphingHeader showCompact={isCompact} openContact={() => setContactOpen(true)} openLogin={(user) => {user != null ? mlogout(true) : setLoginOpen(true)}}/>
		{/*<main className={styles["page-layout"]}>
		  <aside className={`${styles["left-column"]} ${'fade-in-up'}`}>
		  {user != null ? <MiniProfile user={user}/> : <> </>}
		  <HowItWorks />
		  {isMobile == false ? <> <NewFeatures />
		  <CommunityRules /> </> : <> </>}
		  </aside>

		  <section className={`${styles["main-column"]} ${'fade-in-up'}`}>
			<TrendingCarousel />
			<DebateFeed
			  arenas={arenas}
			  loadMore={loadMore}
			  hasMore={hasMore}
			  loading={loading}
			  currentUser={user}
			  onJoin={handleJoin}/>
		  </section>

		  <aside className={`${styles["right-column"]} ${'fade-in-up'}`}><PublicLeaderboard user={user}/></aside>
		</main>*/}
		<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
		<AuthToggle isLOpen={isLoginOpen} onLClose={() => setLoginOpen(false)} />

	</>
	);
}

export default Home;

